import { render, staticRenderFns } from "./tydy.vue?vue&type=template&id=c0182f44&"
import script from "./tydy.vue?vue&type=script&lang=js&"
export * from "./tydy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports